export const gameCategories = [
    { name: "Memory", path: "/games/memory", color: "bg-[#FFF0C9]" },
    { name: "Counting", path: "/games/counting", color: "bg-[#DDF5ED]" },
    { name: "Addition", path: "/games/adding", color: "bg-[#E7E0FA]" },
    { name: "Subtraction", path: "/games/subtracting", color: "bg-[#FFE2DE]" },
    { name: "Multiplication", path: "/games/multiplication", color: "bg-[#DDEFFD]" },
    { name: "Division", path: "/games/division", color: "bg-[#FBE1EE]" },
    { name: "Shapes", path: "/games/shapes", color: "bg-[#E2F0D5]" },
    { name: "Fractions", path: "/games/fraction", color: "bg-[#FFF0C9]" },
];

export const parentGuides = [
    {
        slug: "ages-4-6",
        label: "Ages 4–6",
        path: "/math-games/ages-4-6/",
        description: "Early counting, shapes, memory, and number confidence.",
        intro: "At this age, short and playful sessions can help children connect numbers with quantities, recognize patterns, and become comfortable trying again.",
        skills: ["Counting and number recognition", "Comparing simple quantities", "Shape and color recognition", "Visual memory"],
        games: ["counting", "shapes", "memory"],
    },
    {
        slug: "ages-7-9",
        label: "Ages 7–9",
        path: "/math-games/ages-7-9/",
        description: "Addition, subtraction, multiplication, and mental math.",
        intro: "Children ages 7–9 are often ready to strengthen number facts while learning to choose efficient ways to solve a problem.",
        skills: ["Addition and subtraction fluency", "Early multiplication", "Mental calculation", "Logical comparison"],
        games: ["adding", "subtracting", "multiplication", "compare"],
    },
    {
        slug: "ages-10-12",
        label: "Ages 10–12",
        path: "/math-games/ages-10-12/",
        description: "Fractions, decimals, division, and stronger problem solving.",
        intro: "Older children can use game-based practice to reinforce multi-step skills and build speed without losing conceptual understanding.",
        skills: ["Multiplication and division", "Fractions and decimals", "Mental math strategies", "Multi-step problem solving"],
        games: ["multiplication", "division", "fraction", "decimal"],
    },
    {
        slug: "multiplication",
        label: "Multiplication",
        path: "/math-games/multiplication/",
        description: "Practice multiplication facts through short game sessions.",
        intro: "Multiplication practice works best when children understand equal groups first, then build accurate recall through regular, manageable sessions.",
        skills: ["Equal groups", "Times-table recall", "Patterns in multiplication", "Mental multiplication"],
        games: ["multiplication"],
    },
    {
        slug: "fractions",
        label: "Fractions",
        path: "/math-games/fractions/",
        description: "Build visual and numerical understanding of fractions.",
        intro: "Fraction games can connect pictures, parts of a whole, and number notation before children move into fraction operations.",
        skills: ["Parts of a whole", "Comparing fractions", "Improper and mixed fractions", "Fraction operations"],
        games: ["fraction"],
    },
    {
        slug: "offline",
        label: "Offline Math Games",
        path: "/math-games/offline/",
        description: "Ideas and games for learning without a constant connection.",
        intro: "Offline-friendly practice can make learning easier during travel, quiet time, or in homes where a reliable connection is not always available.",
        skills: ["Independent practice", "Travel-friendly learning", "Focused screen time", "Consistent routines"],
        games: ["counting", "adding", "memory"],
    },
    {
        slug: "ad-free",
        label: "Ad-Free Math Games",
        path: "/math-games/ad-free/",
        description: "A calmer learning experience designed for children.",
        intro: "A learning environment without third-party advertising helps children stay focused and gives parents more confidence about what appears on screen.",
        skills: ["Focused practice", "Child-friendly navigation", "Fewer interruptions", "Parent confidence"],
        games: ["memory", "counting", "multiplication", "fraction"],
    },
];

export const guideBySlug = Object.fromEntries(parentGuides.map((guide) => [guide.slug, guide]));
